import { Routes, Route } from "react-router-dom";
import AuthLayout from "../layout/AuthLayout";
import { HomeRedirect, RoleRoute } from "../layout/RoleRoute";
import LoginPage from "../pages/login/LoginPage";
import DashboardPage from "../pages/dashboard/DashboardPage";
import ClassesPage from "../pages/classes/ClassesPage";
import ClassStudentsPage from "../pages/classes/ClassStudentsPage";
import AttendancePage from "../pages/attendance/AttendancePage";
import SchoolsPage from "../pages/schools/SchoolsPage";
import TeachersPage from "../pages/teachers/TeachersPage";
import {
  ADMIN_ROLES,
  RoleName,
  SCHOOL_MEMBER_ROLES,
} from "../common/enum/Role";

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected routes with Context-based auth */}
      <Route element={<AuthLayout />}>
        <Route element={<RoleRoute roles={ADMIN_ROLES} />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/schools" element={<SchoolsPage />} />
        </Route>
        <Route element={<RoleRoute roles={[RoleName.SCHOOL]} />}>
          <Route path="/teachers" element={<TeachersPage />} />
        </Route>
        <Route element={<RoleRoute roles={SCHOOL_MEMBER_ROLES} />}>
          <Route path="/classes" element={<ClassesPage />} />
          <Route
            path="/classes/:classId/students"
            element={<ClassStudentsPage />}
          />
          <Route
            path="/classes/:classId/attendance"
            element={<AttendancePage />}
          />
        </Route>
        <Route path="/" element={<HomeRedirect />} />
        {/* Catch all - redirect to the role's home page */}
        <Route path="*" element={<HomeRedirect />} />
      </Route>
    </Routes>
  );
}

export default App;
